export default function formatMessageContentSelect ({
    answer,
    mode
}) {
    return {
        mode,
        text: answer
    }
}
